import ResponsibilityPerformance from "@/assets/js/responsibilities/performances/responsibility-performance";

export default class extends ResponsibilityPerformance {
  get performed() {
    return this.performers.count >= 2;
  }
}
